module.exports = __webpack_public_path__ + "static/media/Check_Done.8902b0e4.svg";